import { Breadcrumbs, CardContent, Typography } from '@mui/material';
import { FC } from 'react';
import { BackendApplication } from '@/types/backend';

type ApplicationDetailsProps = {
  application?: BackendApplication;
  path: string | undefined;
};

const ApplicationDetails: FC<ApplicationDetailsProps> = ({ application, path }) => {
  const splitPath = ['', ...(path?.split('/') ?? '')];

  /**
   * The 'Z' changes the date shown from UTC to local
   */
  const ensureTimezoneIncluded = (timestamp: string): string => (timestamp.includes('Z') ? timestamp : timestamp + 'Z');

  return (
    <CardContent sx={{ width: '100%', height: '14rem' }}>
      <Typography variant='h5' color='text.secondary' gutterBottom>
        {application?.label || ''}
      </Typography>
      <Breadcrumbs>
        {splitPath?.map((part) => (
          <Typography color='text.secondary' fontFamily='monospace' fontSize='0.75rem' key={part}>
            {part}
          </Typography>
        ))}
      </Breadcrumbs>
      <Typography sx={{ fontSize: 14 }} component='div'>
        {application?.name || ''}
      </Typography>
      {application?.applicationId && (
        <Typography sx={{ fontSize: 14 }} component='div' color='text.secondary' fontFamily='monospace'>
          ID: {application.applicationId}
        </Typography>
      )}
      <Typography sx={{ mb: 1.5 }} color='text.secondary' fontFamily='monospace'>
        {application ? `Revision: ${application?.revision}` : ''}
      </Typography>
      <Typography sx={{ fontSize: 14 }} component='div'>
        {application?.description || ''}
      </Typography>
      <Typography variant='body2'>
        {application && application.revisionCreated
          ? `Updated ${new Date(ensureTimezoneIncluded(application.revisionCreated))
              .toLocaleString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              })
              .replace(',', '')}`
          : ''}
        <br />
        {application ? `by ` : ''}
        {application && application.updatedBy
          ? `${application.updatedBy.firstName} ${application.updatedBy.lastName}`
          : ''}
      </Typography>
    </CardContent>
  );
};

export default ApplicationDetails;
